import {isEmptyObject} from "./utils/is-empty-object";
import Swiper from 'swiper';
import {Navigation, Parallax} from 'swiper/modules';
import {RenderPosition, render} from "./utils/render";
import LiComponent from "./components/li";
import NewsListComponent from "./components/news-list-component";
import NewsCardComponent from "./components/news-card";
import {getNewsData} from "./data/news";


export const renderNewsList = (container, data) => {
  const newsList = data;
  if (isEmptyObject(newsList.news)) {
    return;
  }

  const wrapComponent = new NewsListComponent();
  const listElement = wrapComponent.getElement().querySelector(`.main-page__list`);

  Object.values(newsList.news)
    .forEach((news) => {
      // const news = newsList[itemId];
      const liItemComponent = new LiComponent({
        className: `news__item swiper-slide`,
      });
      render(listElement, liItemComponent.getElement(), RenderPosition.BEFOREEND);

      const productCardComponent = new NewsCardComponent({
        data: getNewsData(news),
      });

      render(liItemComponent.getElement(), productCardComponent.getElement(), RenderPosition.BEFOREEND);
    });

  render(container, wrapComponent.getElement(), RenderPosition.BEFOREEND);

  // const swiper = new Swiper(".swiper--news", {
  //   speed: 600,
  //   parallax: true,
  //   pagination: {
  //     el: ".swiper-pagination",
  //     clickable: true,
  //   },
  //   navigation: {
  //     nextEl: ".swiper-button-next",
  //     prevEl: ".swiper-button-prev",
  //   },
  // });

  const sw = new Swiper(`.swiper--news`, {
    modules: [Navigation, Parallax],
    direction: `horizontal`,
    spaceBetween: 10,
    speed: 1000,
    parallax: true,
    slideActiveClass: `news__item--active`,
    slidesPerView: 1,
    // autoHeight: true,

    navigation: {
      nextEl: `.swiper__button--next`,
      prevEl: `.swiper__button--prev`,
      hiddenClass: `swiper__button--hidden`,
      disabledClass: `swiper__button--disabled`,
      lockClass: `swiper__button--lock`
    },

    breakpoints: {
      320: {
        slidesPerView: 1,
      },
      // 420: {
      //   slidesPerView: 2,
      // },
      640: {
        slidesPerView: 2,
      },

      900: {
        slidesPerView: 3,
      },
      // 1100: {
      //   slidesPerView: 4,
      // }
    }
  });
};
